<button [disabled]="!enabled" (click)="onClick()"><ng-content></ng-content></button>
